export default (component) => {
  if (!component.mixins) {
    component.mixins = []
  }

  component.mixins.push({
    inject: {
      modal: {
        default: null
      }
    },
    watch: {
      '$modal.focused': {
        handler(modal) {
          if (modal && this.showPopper) {
            this.showPopper = false
          }
        }
      }
    },
    created() {
      if (this.modal && !this._modalPatch) {
        this._modalPatch = true
        const update = this.updatePopper

        this.updatePopper = () => {
          update.call(this)

          const zIndex = this.$el.style.zIndex
          const mIndex = this.modal.zIndex

          if (zIndex < mIndex) {
            const diff = mIndex - zIndex
            this.$el.style.zIndex = zIndex + diff
          }
        }
      }
    }
  })
}
